module.exports = __webpack_public_path__ + "img/1.3770d6b3.png";